import { Routes, Route } from 'react-router-dom'
import Display from './display/Display'
import Admin from './admin/Admin'

function App() {
  return (
    <Routes>
      <Route path="/display" element={<Display />} />
      <Route path="/admin/*" element={<Admin />} />
      <Route path="/" element={<Display />} />
    </Routes>
  )
}

export default App
